<template>
    <div>
        <AppHeader/>
        <section class="section">
            <div class="container-fluid">
                <router-view></router-view>
            </div>
        </section>
    </div>
</template>

<script>
import AppHeader from "./AppHeader";

export default {
    name: "App",
    components: { AppHeader }
};
</script>
